import { setActiveProductionGroupGuid } from '../store/batchesAndBundlesTabSlice';
import { loadComponentsForProductionGroup } from './componentActions';
import { loadProductionGroupData } from './loadProductionGroupData';
import { AsyncThunkActionVoid } from './thunkActions';

export function selectProductionGroup(productionGroupGuid: string | null): AsyncThunkActionVoid {
  return async function selectProductionGroupThunkAction(dispatch) {
    dispatch(setActiveProductionGroupGuid(productionGroupGuid));
    if (productionGroupGuid === null) return;

    await dispatch(loadProductionGroupData(productionGroupGuid));
    await dispatch(loadComponentsForProductionGroup(productionGroupGuid));
  };
}
